const ConsultaIcon = ({ color, width, height }) => {
  return (
    <svg
      width={width ? width: "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4 7.2C21.072 7.2 21.6 7.716 21.6 8.4C21.6 8.71826 21.4736 9.02348 21.2485 9.24853C21.0235 9.47357 20.7183 9.6 20.4 9.6C19.716 9.6 19.2 9.06 19.2 8.4C19.2 7.716 19.716 7.2 20.4 7.2ZM2.4 0C0.8004 0 0 0.8004 0 2.4V10.8C0 14.352 2.628 17.4 6.168 17.892C6.912 21.504 10.104 24 13.8 24C14.8243 24 15.8386 23.7982 16.7849 23.4063C17.7313 23.0143 18.5911 22.4397 19.3154 21.7154C20.0397 20.9911 20.6143 20.1313 21.0063 19.1849C21.3982 18.2386 21.6 17.2243 21.6 16.2V11.772C22.992 11.268 24 9.948 24 8.4C24 7.44522 23.6207 6.52955 22.9456 5.85442C22.2705 5.17929 21.3548 4.8 20.4 4.8C19.4452 4.8 18.5295 5.17929 17.8544 5.85442C17.1793 6.52955 16.8 7.44522 16.8 8.4C16.8 9.948 17.808 11.28 19.2 11.772V16.092C19.2 19.092 16.8 21.492 13.8 21.492C11.4 21.492 9.384 20.04 8.664 17.88C12 17.16 14.4 14.16 14.4 10.8V2.4C14.4 0.8004 13.5996 0 12 0H10.8C9.9996 0 9.6 0.3996 9.6 1.2C9.6 2.0004 9.9996 2.4 10.8 2.4H12V10.8C12 12.073 11.4943 13.2939 10.5941 14.1941C9.69394 15.0943 8.47304 15.6 7.2 15.6C5.92696 15.6 4.70606 15.0943 3.80589 14.1941C2.90571 13.2939 2.4 12.073 2.4 10.8V2.4H3.6C4.4004 2.4 4.8 2.0004 4.8 1.2C4.8 0.3996 4.4004 0 3.6 0H2.4Z"
        fill={color}
      />
    </svg>
  );
};
export default ConsultaIcon;
